import { create } from "zustand"

// Boot lifecycle of the Intercom widget, shared between the provider (which drives it)
// and the launcher (which reacts to it). Without this contract the launcher can't tell
// whether the script is still loading or has failed, so it silently no-ops.
export type IntercomStatus = "idle" | "loading" | "ready" | "error"

interface IntercomStore {
  status: IntercomStatus
  setStatus: (status: IntercomStatus) => void
}

export const useIntercomStore = create<IntercomStore>((set) => ({
  status: "idle",
  setStatus: (status) => set({ status }),
}))
